var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOctagonAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 32H24.02M24 16V24M30.624 4C31.6848 4.00023 32.702 4.4218 33.452 5.172L42.828 14.548C43.5782 15.298 43.9998 16.3152 44 17.376V30.624C43.9998 31.6848 43.5782 32.702 42.828 33.452L33.452 42.828C32.702 43.5782 31.6848 43.9998 30.624 44H17.376C16.3152 43.9998 15.298 43.5782 14.548 42.828L5.172 33.452C4.4218 32.702 4.00023 31.6848 4 30.624V17.376C4.00023 16.3152 4.4218 15.298 5.172 14.548L14.548 5.172C15.298 4.4218 16.3152 4.00023 17.376 4H30.624Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonAlert);
export default __webpack_public_path__ + "static/media/octagon-alert.e5e9b86e5e1a6a6fdbd63c280ea48045.svg";
export { ForwardRef as ReactComponent };